<template>
    <div>
      <div class="fb-share-button" 
           :data-href="props.url" 
           data-layout="button_count">
      </div>
    </div>
  </template>
  
  <script setup lang="ts">
  
  const props= {
      url: {
        type: String,
        required: true
      }
    }
  
  </script>
  